export default {
  ERROR_GETTING_CURRENT_USER: 'We ran into issues getting your account info',
  ERROR_GETTING_ORGANIZATION: 'We ran into issues getting your organization',
  ERROR_GETTING_ORGANIZATION_STAFF: 'We ran into issues getting your staff members',
  ERROR_GETTING_ORGANIZATION_VENUES: 'We ran into issues getting your venues',
  ERROR_GETTING_ORGANIZATION_VENUE: 'We ran into issues getting your venue',
  ERROR_GETTING_ORGANIZATION_STAFF_BY_ID: 'We ran into issues getting your staff member info',
  ERROR_GETTING_ORGANIZATION_CUSTOMERS: 'We ran into issues getting your customers',
  ERROR_GETTING_CUSTOMER_ADMISSION_GROUPS: 'We ran into issues getting your customers\' reservations',
  ERROR_GETTING_PERMISSIONS: 'We ran into issues getting permissions',
  ERROR_GETTING_TAGS: 'We ran into issues getting tags',

  //permisison errors
  ERROR_NOT_ALLOWED_TO_WRITE_ORGANIZATION: 'You do not have permission to update this organization',
  ERROR_UPDATE: 'We ran into issues while updating'
};



// WEBPACK FOOTER //
// ./src/constants/errorMessages.js